import { MultiSectionDigitalClock } from "@mui/x-date-pickers";
import moment from "moment";
import { useState } from "react";
import { useModalControl } from "../../customHooks/useModalControl";
import { useWindowDimensions } from "../../customHooks/useWindowDimensions";
import { formatDate } from "../../helperFunctions";
import { Icon } from "../icons/icon";
import { ModalComponent } from "../modals";
import { PopoverMenu } from "./popover";
import { TextInput } from "./textInput";

export const TimeComp = ({
  clicked,
  date,
  minTime,
  referenceDate,
  setDate = () => {},
  className = "",
  disablePast = false,
  disableFuture = false,
}: {
  clicked?: boolean;
  date?: Date | null;
  minTime?: moment.Moment;
  referenceDate?: moment.Moment;
  setDate?: (date: moment.Moment | null) => void;
  className?: string;
  disablePast?: boolean;
  disableFuture?: boolean;
}) => {
  return (
    <div className={className}>
      <MultiSectionDigitalClock
        value={clicked && date === null ? null : moment(date)}
        onChange={(newDate) => {
          setDate(newDate);
          // close();
        }}
        ampm
        minTime={minTime}
        referenceDate={referenceDate}
        disablePast={disablePast}
        disableFuture={disableFuture}
        className="hide-scroll-bar !border-0 !border-b-0"
        timeSteps={{
          minutes: 1,
        }}
        sx={{
          "& .MuiList-root": {
            border: "none !important",
          },
          "& .MuiMultiSectionDigitalClockSection-root": {
            border: "none !important",
            scrollbarWidth: "none !important",
            display: "flex",
            flexDirection: "column",
            gap: "0px",
            ":hover": {
              border: "none !important",
              scrollbarWidth: "none !important",
            },
          },
          "& .MuiMultiSectionDigitalClockSection-item": {
            fontFamily: "Satoshi !important",
            fontSize: "12px !important",
            fontWeight: 500,
            color: "#055139",
            borderRadius: "400px",
            aspectRatio: "1",
            width: "40px",
            height: "40px",
            minWidth: "40px",
            minHeight: "40px",
            maxWidth: "40px",
            maxHeight: "40px",
            //   border: "1px solid",
            margin: "0px",
            backgroundColor: "trasparennt",
            ":hover": {
              backgroundColor: "transparent",
            },
          },
          "& .MuiMultiSectionDigitalClockSection-item.Mui-selected": {
            fontWeight: "700 !important",
            backgroundColor: "#055139",
            color: "white",
            ":hover": {
              backgroundColor: "#055139",
              color: "white",
            },
          },
        }}
      />
    </div>
  );
};

export const TimeInput = ({
  placeholder = "",
  errors = "",
  title = "",
  date,
  minTime,
  referenceDate,
  setDate = () => {},
  onBlur = () => {},
  className = "",
  name,
  disablePast = false,
  disableFuture = false,
  dateDisplayFormat = "hh:mm A",
}: {
  placeholder: string;
  name: string;
  errors?: string;
  title?: string;
  date?: Date | null;
  minTime?: moment.Moment;
  referenceDate?: moment.Moment;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  setDate?: (date: moment.Moment | null) => void;
  className?: string;
  disablePast?: boolean;
  disableFuture?: boolean;
  dateDisplayFormat?: string;
}) => {
  const [clicked, setClicked] = useState<boolean>(false);

  const { modal, modalOpen, handleModalOpen, handleModalClose } =
    useModalControl();

  const { width } = useWindowDimensions();

  return (
    <>
      <PopoverMenu
        onPopoverClick={(e) => {
          e.stopPropagation();

          if (width < 768) {
            e.preventDefault();
            handleModalOpen("timePopOverMenuModal");
          }
        }}
        customMenuItems={({ close }) => {
          return (
            <TimeComp
              clicked={clicked}
              date={date}
              minTime={minTime}
              referenceDate={referenceDate}
              setDate={setDate}
              className={className}
              disablePast={disablePast}
              disableFuture={disableFuture}
            />
          );
        }}
        menuClassName="rounded-xl bg-white !shadow-lg border z-[999] pl-4"
        className={`w-full`}
        position="bottom"
      >
        <button className="h-fit w-full text-left" type="button">
          <TextInput
            type="text"
            name={name}
            value={formatDate(date, dateDisplayFormat)}
            placeholder={placeholder}
            onChange={() => {}}
            onBlur={(e) => {
              setClicked(true);
              onBlur(e);
            }}
            hasTitle={!!title}
            title={title}
            errors={errors}
            containerClassName=""
            readOnly
            inputClass="!cursor-pointer"
            hasIcon={false}
            customIcon={<Icon svg="clock" width={20} height={20} />}
            customIconPosition="right"
          />
        </button>
      </PopoverMenu>

      <ModalComponent
        isModalOpen={modalOpen && modal === "timePopOverMenuModal"}
        onModalClose={() => {
          handleModalClose();
        }}
        hasButtons={false}
        showMobileTopBar
        showHeader={false}
        closeOnOutsideClick
        childrenClassName="items-center justify-center"
        modalClassName="items-center justify-center "
      >
        <TimeComp
          clicked={clicked}
          date={date}
          minTime={minTime}
          referenceDate={referenceDate}
          setDate={setDate}
          className={`${className}`}
          disablePast={disablePast}
          disableFuture={disableFuture}
        />
      </ModalComponent>
    </>
  );
};
